import script from "./EnergyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnergyView.vue?vue&type=script&setup=true&lang=ts"

import "./EnergyView.vue?vue&type=style&index=0&id=b1e28b82&lang=css"

const __exports__ = script;

export default __exports__